<template>
  <div>
    <v-container>
      <v-layout text-xs-center wrap>
        <v-flex mb-3 xs12>
          <img
            :srcset="srcset"
            :src="require('../assets/logo_diginamic.png')"
            width="378"
          />
          <p class="mt-1">
            „Eine Zusatzdienstleistung des Messstellenbetreibers der Netze BW“
          </p>
        </v-flex>

        <v-flex mb-4 xs12>
          <h1 class="display-2 font-weight-bold mb-3">
            Exporter LoRaWAN Wasser&shy;zähler&shy;stände
          </h1>
          <p class="subheading font-weight-regular">
            Mithilfe dieser Webseite können Sie die Zählerstände Ihrer Wasserzähler in dem
            für Ihr Abrechnungssystem benötigten Format herunterladen.
          </p>
        </v-flex>

        <v-flex mb-4 xs12>
          <v-stepper v-model="e6" vertical>
            <v-stepper-step :complete="e6 > 1" step="1" color="secondary">
              Wählen Sie Ihr Abrechnungssystem für Ihre Wasserzähler aus
              <small>Sie bekommen dann das passende Format</small>
            </v-stepper-step>

            <v-stepper-content step="1">
              <v-select
                :items="encoders"
                v-model="encoder"
                label="Abrechnungssystem"
              ></v-select>
              <v-btn color="primary" @click="e6 = 2">Weiter</v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" step="2" color="secondary">
              Ändern Sie diese URL des LoRaWAN Netzwerkserver ab
              <small
                >Optional, nur falls Sie eine andere URL genannt bekommen haben</small
              >
            </v-stepper-step>

            <v-stepper-content step="2">
              <v-text-field
                v-model="baseURL"
                label="LoRaWAN Netzwerkserver"
                required
                @change="loadFolders"
              ></v-text-field>
              <v-btn flat @click="e6 = 1">Zurück</v-btn>
              <v-btn color="primary" @click="e6 = 3" :disabled="!baseURL">Weiter</v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 3" step="3" color="secondary"
              >Geben Sie den von der Netze BW erhaltenen Zugangscode (API-Schlüssel)
              ein</v-stepper-step
            >

            <v-stepper-content step="3">
              <v-text-field
                v-model="apikey"
                :counter="32"
                :rules="apikeyRules"
                label="Zugangscode (API Schlüssel)"
                required
              ></v-text-field>
              <v-btn flat @click="e6 = 2">Zurück</v-btn>
              <v-btn color="primary" @click="e6 = 4" :disabled="!apikey">Weiter</v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 4" step="4" color="secondary"
              >Wählen Sie die Gruppe der Wasserzähler aus, die Sie herunterladen möchten
              <small>(z.B. Bezirk, Charge, …)</small></v-stepper-step
            >
            <v-stepper-content step="4">
              <v-autocomplete
                v-model="folder"
                :items="folders"
                item-text="name"
                item-value="slug"
                label="Gruppe"
                persistent-hint
                return-object
                single-line
                required
                :disabled="folders.length == 0"
                :loading="loading"
              ></v-autocomplete>
              <v-btn flat @click="e6 = 3">Zurück</v-btn>
              <v-btn color="primary" @click="e6 = 5" :disabled="!folder">Weiter</v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 5" step="5" color="secondary"
              >Hier können Sie das gewünschte Ablesedatum einstellen
              <small
                >Beispiel: wenn 04.02.2021 eingegeben wird, wir der aktuellste Zählerstand
                VOR dem 04.02.2021 ausgegeben</small
              ></v-stepper-step
            >
            <v-stepper-content step="5">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Spätestes Ablesedatum vor dem"
                    hint="DD.MM.YYYY"
                    persistent-hint
                    prepend-icon="event"
                    @blur="date = parseDate(dateFormatted)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
              <v-btn flat @click="e6 = 4">Zurück</v-btn>
              <v-btn color="primary" @click="e6 = 6" :disabled="!date">Weiter</v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 6" step="6" color="secondary"
              >Falls alle Einstellungen korrekt sind, können Sie jetzt mit einem Klick auf
              den Button die passende Datei erzeugen lassen
              <small>
                Das Erzeugen der Datei kann bei mehr als 1000 Wasserzähler auch länger als
                5 Minuten dauern!</small
              ></v-stepper-step
            >
            <v-stepper-content step="6">
              <v-btn flat @click="e6 = 5">Zurück</v-btn>
              <v-btn
                color="primary"
                @click="getDevices"
                :disabled="folder == null"
                :loading="readingsLoading"
                >Datei erzeugen</v-btn
              >
            </v-stepper-content>
            <v-stepper-step :complete="e6 > 7" step="7" color="secondary"
              >Datei herunterladen
              <small>
                Die heruntergeladene Datei direkt unverändert ins Abrechnungssystem
                importieren!</small
              ></v-stepper-step
            >
            <v-stepper-content step="7">
              <v-btn flat @click="e6 = 6">Zurück</v-btn>
              <v-btn color="primary" :disabled="blob == null" @click="saveFile"
                >Datei herunterladen</v-btn
              >
            </v-stepper-content>
          </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer fixed class="pa-3">
      <v-spacer></v-spacer>
      <div>
        <a class="grey--text text--darken-2" href="mailto:diginamic@netze-bw.de"
          >Kontakt</a
        >
        |
        <a class="grey--text text--darken-2" href="https://www.netze-bw.de/datenschutz"
          >Datenschutz</a
        >
        |
        <a class="grey--text text--darken-2" href="https://www.netze-bw.de/impressum"
          >Impressum</a
        >
      </div>
      <v-spacer></v-spacer>
    </v-footer>
  </div>
</template>

<script>
//import Papa from 'papaparse'
import axios from "axios";
import rateLimit from "axios-rate-limit";
import { Promise } from "q";
import { saveAs } from "file-saver";
//import { saveAs } from "file-saver"
const http = rateLimit(axios.create(), {
  maxRequests: 50,
  perMilliseconds: 10000,
});
const getQueryStringParams = (query) => {
  return query
    ? (/[?#]/.test(query) ? query.split(/[?#]/)[1] : query)
        .split("&")
        .reduce((params, param) => {
          let [key, value] = param.split("=");
          params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
          return params;
        }, {})
    : {};
};
const getDateFromQuery = (query) => {
  const dateParam = getQueryStringParams(query)["date"] || "";
  const date = Date.parse(dateParam);
  if (Object.is(NaN, date)) {
    return new Date().toISOString().substr(0, 10);
  }
  return new Date(dateParam).toISOString().substr(0, 10);
};
const dataplan = {
  name: "dataplan",
  getHeader() {
    return ["znr;abl_dat;abl_stand\n"];
  },
  encodeLine(device, reading) {
    const { name } = device;
    let {
      data: {
        body: [
          {
            data: { value_m3, value_1 },
            measured_at,
          },
        ],
      },
    } = reading;
    [measured_at] = measured_at.split("T");
    let [year, month, day] = measured_at.split("-");
    measured_at = `${day}.${month}.${year}`;
    value_m3 = Number((value_1 / 1000 || value_m3).toFixed(4));
    let line = [name, measured_at, value_m3].join(";");
    return line + "\n";
  },
  getLineWhenNoReading(device) {
    return device.name + "\n";
  },
  getFileExtension() {
    return ".csv"
  },
};

const kommOne = {
  name: "komm.one",
  getHeader() {
    return [];
  },
  encodeLine(device, reading) {
    const { name } = device;
    let {
      data: {
        body: [
          {
            data: { value_m3, value_1 },
            measured_at,
          },
        ],
      },
    } = reading;
    [measured_at] = measured_at.split("T");
    let [year, month, day] = measured_at.split("-");
    measured_at = `${day}${month}${year}`;
    value_m3 = Number((value_1 / 1000 || value_m3).toFixed(0));
    let line = [name, measured_at, value_m3, "1"].join(";");
    return line + "\r\n";
  },
  getLineWhenNoReading() {
    return "";
  },
  getFileExtension() {
    return ".txt"
  },
};
const getDefaultFormat = () => {
  const formatParam = getQueryStringParams(window.location.href)["format"] || "";
  if (["kommone", "komm.one"].includes(formatParam.toLowerCase())) {
    return kommOne;
  }
  return dataplan;
};

export default {
  data: (vm) => ({
    valid: true,
    baseURL:
      getQueryStringParams(window.location.href)["base_url"] || "https://lns-intern.netze-bw.de",
    apikey: getQueryStringParams(window.location.href)["apikey"] || "",
    apikeyRules: [
      (v) => !!v || "API Schlüssel ist ein Pflichtfeld",
      (v) => (v && v.length == 32) || "API Schlüssel muss 32 Zeichen haben",
    ],
    // file: null,
    // fileContent: null,
    errors: null,
    folders: [],
    folder: null,
    loading: false,
    readingsLoading: false,
    date: getDateFromQuery(window.location.href),
    dateFormatted: vm.formatDate(getDateFromQuery(window.location.href)),
    menu: false,
    blob: null,
    encoder: getDefaultFormat(),
    encoders: [
      { text: "Dataplan", value: dataplan },
      { text: "Komm.ONE Finanzen_Infoma", value: kommOne },
    ],
    e6: 1,
    //outLines: []
    //errorLines: []
    srcset: require('../assets/logo_diginamic.svg') + ' 378w, ' + require('../assets/logo_diginamic.png') + ' 378w',
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(val);
    },
    apikey: function (val) {
      if (val.length === 32) {
        this.getFolders();
      } else {
        this.folders = [];
      }
    },
  },
  mounted: function () {
    this.getFolders();
  },
  methods: {
    loadFolders() {
      if (this.apikey && this.apikey.length === 32) {
        this.getFolders();
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    setBlob: function (values) {
      this.blob = new Blob(values, { type: "text/csv;charset=utf-8" });
    },
    saveFile: function () {
      saveAs(this.blob, "export_" + this.date + this.encoder.getFileExtension());
    },
    loadAll: function (url, after_id, with_profile) {
      return http
        .get(url, {
          params: {
            auth: this.apikey,
            limit: 100,
            retrieve_after: after_id || undefined,
            with_profile: with_profile || undefined,
          },
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          //responseType: 'text'
        })
        .then((r) => {
          if (r.data != null && r.data.body != null && r.status == 200) {
            if (r.data.retrieve_after_id) {
              return this.loadAll(
                url,
                r.data.retrieve_after_id,
                with_profile
              ).then((list) => list.concat(r.data.body));
            } else {
              return r.data.body;
            }
          } else return Promise.reject();
        });
    },
    getFolders: function () {
      if (!!this.apikey && this.apikey.length === 32) {
        this.loading = true;
        this.loadAll(this.baseURL + "/api/v1/tags")
          .then((folders) => {
            this.$set(this, "folders", folders);
            var queryFolder = getQueryStringParams(window.location.href)["folder"];
            if (queryFolder != null) {
              var folder = this.folders.find((f) => {
                return f.slug != null && f.slug == queryFolder;
              });
              if (typeof folder !== "undefined") {
                this.$set(this, "folder", folder);
              }
            }
          })
          .catch((error) => {
            // handle error
            // eslint-disable-next-line
            console.log(error);
            this.$set(this, "folders", []);
          })
          .finally(() => (this.loading = false));
      }
    },
    getReading: async function (device) {
      try {
        const r = await axios.get(
          this.baseURL + "/api/v1/devices/" + device.slug + "/readings",
          {
            params: {
              auth: this.apikey,
              limit: 1,
              before: this.date,
              filter: "data.value_1 != null || data.value_m3 != null",
            },
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        return this.encoder.encodeLine(device, r);
      } catch (error) {
        if (error.response && error.response.status === 429) {
          // eslint-disable-next-line
          console.log("Retry ...");
          return new Promise((resolve) => {
            setTimeout(() => resolve(this.getReading(device)), 5000);
          });
        } else {
          return this.encoder.getLineWhenNoReading(device);
        }
      }
    },
    getDevices: async function () {
      this.readingsLoading = true;
      let devices = await this.loadAll(
        this.baseURL + "/api/v1/tags/" + this.folder.slug + "/devices",
        undefined,
        1
      ).then((r) => {
        return r.map((device) => {
          const { slug, id, name } = device;
          return {
            slug,
            id,
            name,
          };
        });
      });
      const lines = this.encoder.getHeader();
      for (const d of devices) {
        const r = await this.getReading(d);
        lines.push(r);
      }
      // eslint-disable-next-line
      console.log("saving ...");
      this.setBlob(lines);
      this.readingsLoading = false;
      this.e6 = 7;
    },
    inputFileChanged: function (event) {
      this.file = event.target.files[0];
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
.border-top {
  border-top: 3px solid blue;
  padding-top: 15px;
  margin-top: 50px;
}
.container {
  max-width: 800px;
}
</style>
